//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var EZUIKit;
var ms_ie = false;
var ua = window.navigator.userAgent.toLowerCase();
var old_ie = ua.indexOf("MSIE");
var new_ie = ua.indexOf("trident/");
var is360 = false;
var append = document.getElementById("append");
if (old_ie > -1 || new_ie > -1) {
  EZUIKit = false;
  ms_ie = true;
}
if (window.navigator.appName.indexOf("Microsoft") != -1) {
  me_ie = true;
}
if (window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length) {
  is360 = true;
}

if (ms_ie) {
  EZUIKit = false;
  var DEFAULT_VERSION = 8.0;
  var ua = navigator.userAgent.toLowerCase();
  var isIE = ua.indexOf("msie") > -1;
  var safariVersion;
  if (isIE) {
    safariVersion = ua.match(/msie ([d.]+)/)[1];
  }
  if (safariVersion <= DEFAULT_VERSION) {
    console.log(
      "系统检测到您正在使用ie8以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！"
    );
  }
}
if (EZUIKit != false) {
  EZUIKit = require("@/utils/ezuikit.js");
}
import axios from "axios";
export default {
  name: "AgrMonitoringPreset",
  data() {
    return {
      tableData: [],
      value1: [],
      timeVal: "",
      realData: {
        deviceCode: "-",
        deviceName: "-",
        deviceTypeName: "-",
      },
      videoInfo: {
        deviceCode: "",
      },
      redFlag: "fal",
      offWid: "",
      offHei: "",
      video_Src: "",
      video_Token: "",
      flag: false,
      EZUIKit: EZUIKit,
      player: "",
      loading: null,
      code: this.$route.query.code,
      isTurn: false,
      btnHei: "",
      pointerEventer: false,
    };
  },
  mounted() {
    var foot = document.querySelector(".el-footer");
    if (foot) {
      foot.setAttribute("id", "el-footers");
    }
    this.fn();
  },
  destroyed() {
    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  },
  beforeCreate() {},
  created() {
    this.get_PresetAdd();
  },
  methods: {
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `
       background-color: #f8f8f8;
       `;
      }
    },
    rowClass(row) {
      return `border: 1px solid #e4e4e4;`;
      // if ((row.rowIndex + 1) % 2 == 0) {
      //   return {
      //     border: "1px solid #e4e4e4",
      //   };
      // } else {

      // }
    },
    fn() {
      if (this.player) {
        this.player = null;
        this.player.stop();
      } else {
        let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
        this.realData = {
          deviceCode: this.code,
          deviceName: "farmAllData.deviceName",
          deviceTypeName: "farmAllData.deviceTypeName",
        };
        this.videoInfo.deviceCode = this.realData.deviceCode;
        var dom = document.querySelector(".box-top");
        // var heig = document.querySelector(".videoBtnBox");
        // let ass = heig.offsetHeight;
        this.offWid = dom.offsetWidth * 0.7;
        this.offHei = dom.offsetHeight;
        this.btnHei = this.offHei + 38;
        // console.log(this.btnHei);
        let obj = { deviceSerial: this.realData.deviceCode, channelNo: "1" }; // 1-高清（主码流）、2-流畅（子码流）
        this.$http.agrModel
          .getVideoUrl(obj)
          .then((res) => {
            // console.log(res);
            if (res.data.code === "200") {
              this.pointerEventer = true;

              // console.log("视频接口===", res);
              var that = this;
              this.video_Src = res.data.data.url;
              this.video_Token = res.data.hkystoken;
              this.flag = true;
              // console.log(this.video_Src);
              // console.log(this.video_Token);
              if (this.EZUIKit) {
                this.player = new EZUIKit.EZUIKitPlayer({
                  id: "playWindY",
                  url: that.video_Src,
                  autoplay: true,
                  accessToken: that.video_Token,
                  width: this.offWid,
                  height: this.offHei,
                  themeData: this.security,
                });
                // console.log(this.offWid);
              } else {
                this.$message({
                  message:
                    "该浏览器对于视频监控不能实现完美体验，请更换或升级浏览器访问！",
                  type: "error",
                  customClass: "customClass",
                });
              }
            } else if (res.code == "20014") {
              this.pointerEventer = false;
              this.flag = false;
              this.$message({
                message: "设备不存在",
                type: "error",
                customClass: "customClass",
              });
            } else if (res.code == "20018") {
              this.pointerEventer = false;

              this.flag = false;
              this.$message({
                message: "设备异常，请联系管理员",
                type: "error",
                customClass: "customClass",
              });
            } else {
              this.pointerEventer = false;

              this.flag = false;
              this.$message({
                message: "设备不在线",
                type: "error",
                customClass: "customClass",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            console.log("视频加载失败");
          });
      }
      // });
    },
    get_PresetAdd() {
      let obj = { deviceSerial: this.code };
      this.$http.agrModel.getPresetGet(obj).then((res) => {
        if (res.status == 1) {
          this.tableData = res.data;
        } else {
          this.$message({
            message: res.errMsg,
            type: "error",
          });
        }
      });
    },

    // 添加拍摄点
    trueBtn() {
      // console.log(this.timeVal);
      if (this.timeVal == null || this.timeVal == "") {
        this.$message({
          message: "请优先选择时间点",
          type: "warning",
        });
      } else {
        this.lodFn();

        let times = this.timeVal.substring(0, 2);
        // console.log(times);
        var objDate = {
          deviceSerial: this.code,
          timeH: times,
          channelNo: "1",
        };
        this.$http.agrModel.getPresetAdd(objDate).then((res) => {
          // console.log(res);
          if (res.status == "1") {
            this.get_PresetAdd();
            this.loading.close();
            if (
              res.data.msg.includes(
                "已存在拍攝点。请删除或者重新选择其他时间点"
              )
            ) {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            } else if (res.data.msg.includes("设备不在线")) {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            }
          } else {
            this.loading.close();
            this.$message({
              message: res.errMsg,
              type: "error",
            });
          }
        });
      }
    },
    // 删除拍摄点
    removes(item) {
      // console.log(item);
      var node = document.querySelector("body");
      node.setAttribute("id", "pad0");
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.lodFn();
          let obj = {
            deviceSerial: this.code,
            timeH: item.timeH,
            channelNo: "1",
            oldIndex: item.indexs,
          };
          this.$http.agrModel.getPresetDel(obj).then((res) => {
            // console.log(res);
            if (res.status === "1") {
              this.get_PresetAdd();
              this.loading.close();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.loading.close();
              this.$message({
                type: "error",
                message: res.errMsg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    lodFn() {
      this.loading = this.$loading({
        lock: true,
        text: "正在加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    ptzControl(num) {
      this.toControl(this.code, num, 1);
    },
    //控制云台
    toControl(codes, direction, speed) {
      var sta = false;
      if (-1 == direction) {
        this.isTurn = false;
        direction = 2;
        sta = true; //镜头一直转
      }
      if (direction == 111) {
        direction = 2;
        this.isTurn = true;
        //  setTimeout(()=>{
        this.closeControl(codes);
        //  },5000)
      }
      let submitData = {
        deviceSerial: codes,
        channelNo: 1,
        direction: direction,
        speed: speed,
      };
      this.$http.agrModel
        .getVideoStatus(submitData)
        .then((responese) => {
          // console.log(responese);
          if (responese.status === "1") {
            if (!sta) {
              this.closeControl(codes);
            }
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    //停止云台控制
    closeControl(videoInfo) {
      let submitData = {
        deviceSerial: videoInfo,
        channelNo: 1,
      };
      this.$http.agrModel
        .getVideoStop(submitData)
        .then((responese) => {
          // console.log("responese", responese);
          if (responese.status === "1") {
            console.log("关闭成功！");
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    // 拍照
    handleCapture() {
      const loading = this.$loading({
        lock: true,
        text: "正在生成照片，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log("点击了拍照");
      let submitData = {
        deviceSerial: this.code,
      };
      this.$http.agrModel
        .getPhotograph(submitData)
        .then((responese) => {
          // console.log(responese);
          if (responese.status === "1") {
            loading.close();
            this.$message({
              message: "拍照成功",
              type: "success",
              customClass: "customClass",
            });
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    //回到拍摄点位置
    blueTabClick(item) {
      let obj = {
        deviceSerial: this.code,
        channelNo: item.channelNo,
        indexs: item.indexs,
      };
      this.$http.agrModel.getPresetMove(obj).then((res) => {
        // console.log(res);
        if (res.status === "1") {
          this.$message({
            message: res.data.msg,
            type: "success",
            customClass: "customClass",
          });
        } else {
          this.$message({
            message: res.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
  },
  components: {},
};
